import React, { useEffect, useRef, useState } from "react";
import { Formik, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams, useBlocker } from "react-router-dom";
import * as eventsService from "../../services/events.services";
import CustomCkeditor from "../../common/customeditor";
import { RECORDS_PER_PAGE_OPTIONS, SWAL_SETTINGS } from "../../../../utils/Constants";
import {
  formatDecimalForUI,
  handleServerValidations,
  hasPermission,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import { Tooltip, Whisper } from 'rsuite';
import moment from "moment";
import CustomDateTimePickerHotel from "../../common/customDateTimePickerHotel";

const PRIMARY_SINGLE_CAT_ID = "cat_single_primary";
const PRIMARY_DOUBLE_CAT_ID = "cat_double_primary";

const defaultRoomCategories = () => [
  { id: PRIMARY_SINGLE_CAT_ID, label: "Single room", occupancy: "single" },
  { id: PRIMARY_DOUBLE_CAT_ID, label: "Double room", occupancy: "double" },
];

const emptyCategoryRow = () => ({
  enabled: false,
  totalQuantity: "",
  price: "",
  breakfastPrice: "",
});

function mergeServerCategoryQuota(roomCategories, quotaItem) {
  const next = {};
  roomCategories.forEach((cat) => {
    const serverCat = quotaItem.category_quotas?.[cat.id];
    if (serverCat) {
      next[cat.id] = {
        enabled: !!serverCat.is_available,
        totalQuantity:
          serverCat.total_quantity != null ? String(serverCat.total_quantity) : "",
        price: formatDecimalForUI(serverCat.price),
        breakfastPrice: formatDecimalForUI(serverCat.breakfast_price),
      };
    } else if (cat.id === PRIMARY_SINGLE_CAT_ID) {
      next[cat.id] = {
        enabled: !!quotaItem.single_room?.is_available,
        totalQuantity:
          quotaItem.single_room?.total_quantity != null
            ? String(quotaItem.single_room.total_quantity)
            : "",
        price: formatDecimalForUI(quotaItem.single_room?.price),
        breakfastPrice: formatDecimalForUI(quotaItem.single_room?.breakfast_price),
      };
    } else if (cat.id === PRIMARY_DOUBLE_CAT_ID) {
      next[cat.id] = {
        enabled: !!quotaItem.double_room?.is_available,
        totalQuantity:
          quotaItem.double_room?.total_quantity != null
            ? String(quotaItem.double_room.total_quantity)
            : "",
        price: formatDecimalForUI(quotaItem.double_room?.price),
        breakfastPrice: formatDecimalForUI(quotaItem.double_room?.breakfast_price),
      };
    } else {
      next[cat.id] = emptyCategoryRow();
    }
  });
  return next;
}

const Hotels = () => {
  const FORM_MODES = {
    HIDDEN: "hidden",
    ADD: "add",
    EDIT: "edit",
    DUPLICATE: "duplicate",
  };
  const navigate = useNavigate();
  const params = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [previewimage, setPreviewImage] = useState([]);
  const [sorting, setSorting] = useState({});
  const [loader, setLoader] = useState(false);
  const [hotelList, setHotelList] = useState([]);
  const [images, setImages] = useState([]);
  // const [itemperpage, setItemPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [hotelId, setHotelId] = useState();
  const [formMode, setFormMode] = useState(FORM_MODES.HIDDEN);
  const [saveAndNext, setSaveAndNext] = useState(false);
  const customCkeditorRef = useRef(null);
  const imageInputRef = useRef(null);
  const [datalength, setDataLength] = useState("");

  const [offset, setOffsetPage] = useState(0);

  // const [itemperpage, setItemPerPage] = useState(() => {
  //   const stored = sessionStorage.getItem("recordsPerPage");
  //   return stored ? Number(stored) : 10;
  // });

  const [itemperpage, setItemPerPage] = useState(() => {
    const stored = sessionStorage.getItem("recordsPerPage");
    return stored === "all" ? "all" : Number(stored) || 10;
  });
  const perPageValue = itemperpage === "all" ? datalength : itemperpage;

  const [quotaStore, setQuotaStore] = useState({});

  const [statusUpdate, setStatusUpdate] = useState(false);


  const formikRef = useRef();
  const skipUnsavedPromptRef = useRef(false);
  const syncFormikBaseline = () => {
    const formik = formikRef.current;
    if (formik) {
      formik.resetForm({ values: formik.values });
    }
  };

  const [showdefault, setShowDefault] = useState({});

  useEffect(() => {
    getList();
  }, [page, itemperpage, perPageValue, statusUpdate]);

  const getList = () => {
    const formData = new FormData();
    formData.append("page", params.pgno);
    formData.append("per_page", perPageValue);
    // formData.append("per_page", itemperpage);
    // formData.append("sort", JSON.stringify(sorting));
    formData.append("event_id", params.id);
    eventsService
      .ListHotels(formData)
      .then((response) => {
        setLoader(false);
        if (response?.success) {
          setHotelList(response.data.list);
          setDataLength(response?.data?.total_records);
          setPage(response && response.data && response.data.page ? response.data.page : 1);
          setOffsetPage(response?.data?.offset);
        }
      })
      .catch(err => console.log("err", err))
  }

  useEffect(() => {
    eventsService.Details(params.id).then(response => {
      if (response && response.success) {
        setShowDefault(response.data ? response.data : [])
      }
    }).catch(error => {
      console.log("error=====>", error)
    })
  }, [params.id])

  const shouldWarnUnsavedChanges = () => {
    if (skipUnsavedPromptRef.current) {
      return false;
    }
    return !!formikRef.current?.dirty;
  };

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (!shouldWarnUnsavedChanges()) {
      return false;
    }
    return (
      currentLocation.pathname !== nextLocation.pathname ||
      currentLocation.search !== nextLocation.search
    );
  });

  useEffect(() => {
    if (blocker.state === "blocked") {
      const confirmed = window.confirm(
        "Are you sure you want to leave the page before saving your entries?",
      );
      if (confirmed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!shouldWarnUnsavedChanges()) {
        return;
      }
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleImageDelete = (arr, name, setFieldValue) => {
    const remainingimages = Object.values(arr).filter((i) => i.name !== name)
    setPreviewImage(remainingimages);
    setImages(remainingimages);
    setFieldValue('images', remainingimages)
  };

  const hotelsInitialValues = {
    hotelName: "",
    description: "",
    // description_de: "",
    images: "",
    hotelStartDate: "",
    hotelEndDate: "",
    cityTax: "",
    tax: "",
    breakfastTax: "",
    hotelTotalDays: [],
    roomCategories: defaultRoomCategories(),
  }

  const hotelsValidationSchema = Yup.object().shape({
    hotelName: Yup.string()
      .required("Hotel name is required")
      .test("no-spaces", "Hotel name is required", (value) => value.trim()),
    description: Yup.string()
      .required("Description is required")
      .test("no-spaces", "Description is required", (value) => value.trim()),
    images: Yup.mixed()
      .required("Image is required")
      .test("fileType", "Unsupported file format", (value) => {
        if (value?.name) {
          if (value?.name?.includes(".jpg") || value?.name?.includes(".png") || value?.name?.includes(".jpeg") || value?.name?.includes(".gif") || value?.name?.includes(".webp")) {
            return true
          } else {
            return false
          }
        } else {
          return true;
        }
      }),
    // hotelStartDate: Yup.string()
    //   .required("Start date is required")
    //   .test("no-spaces", "Start date is required", (value) => value.trim()),
    // hotelEndDate: Yup.string()
    //   .required("End date is required")
    //   .test("no-spaces", "End date is required", (value) => value.trim()),
    hotelStartDate: Yup.string()
      .required("Start date is required")
      .test("no-spaces", "Start date is required", (value) => value?.trim()),

    hotelEndDate: Yup.string()
      .required("End date is required")
      .test("no-spaces", "End date is required", (value) => value?.trim())
      .test("is-after-start", "End date must be after start date", function (value) {
        const { hotelStartDate } = this.parent;
        if (!hotelStartDate || !value) return true;
        return new Date(value) > new Date(hotelStartDate);
      }),
    // cityTax: Yup.string()
    //   .strict(false)
    //   .trim()
    //   .matches(/^[0-9]+$/, "Decimal values is not allowed in city tax")
    //   .required("City tax is required"),
    // tax: Yup.string()
    //   .strict(false)
    //   .trim()
    //   .matches(/^[0-9]+$/, "Decimal values is not allowed in tax")
    //   .required("Tax is required"),
    // breakfastTax: Yup.string()
    //   .strict(false)
    //   .trim()
    //   .matches(/^[0-9]+$/, "Decimal values is not allowed in breakfast tax")
    //   .required("Breakfast tax is required"),

    // cityTax: Yup.string()
    //   .strict(false)
    //   .trim()
    //   .matches(/^\d+(,\d{1,2})?$/, "Please enter a valid city tax (e.g. 5, 5,75)")
    //   .required("City tax is required"),

    // tax: Yup.string()
    //   .strict(false)
    //   .trim()
    //   .matches(/^\d+(,\d{1,2})?$/, "Please enter a valid tax (e.g. 5, 5,75)")
    //   .required("Tax is required"),

    // breakfastTax: Yup.string()
    //   .strict(false)
    //   .trim()
    //   .matches(/^\d+(,\d{1,2})?$/, "Please enter a valid breakfast tax (e.g. 5, 5,75)")
    //   .required("Breakfast tax is required"),


    // hotelTotalDays: Yup.array().min(1, 'Array must have at least 1 item').of(Yup.object().shape({
    //   checkforSingleRoom: Yup.boolean(),
    //   checkforDoubleRoom: Yup.boolean(),
    //   totalQuantitySingleRoom: Yup.string()
    //     .strict(false).when("checkforSingleRoom", {
    //       is: (checkforSingleRoom) => checkforSingleRoom === true,
    //       then: () => Yup.string().strict(false)
    //         .trim()
    //         .required("Total quantity is required")
    //         .matches(/^[0-9]+$/, "Total quantity should be valid"),
    //       otherwise: () => Yup.string()
    //     }),
    //   // .trim().matches(/^[0-9]+$/, "Total quantity should be valid").required('Total quantity is required'),
    //   priceSingleRoom: Yup.string()
    //     .strict(false).when("checkforSingleRoom", {
    //       is: (checkforSingleRoom) => checkforSingleRoom === true,
    //       then: () => Yup.string().strict(false)
    //         .trim()
    //         .required("price is required")
    //         // .matches(/^[0-9]+$/, "Decimal values is not allowed in price "),
    //         .matches(/^\d+(,\d{1,2})?$/, "Please enter a valid price (e.g. 5, 5,75)"),
    //       otherwise: () => Yup.string()
    //     }),
    //   // .trim().matches(/^[0-9]+$/, "price should be valid").required('price is required'),
    //   breakfastPriceSingleRoom: Yup.string()
    //     .strict(false).when("checkforSingleRoom", {
    //       is: (checkforSingleRoom) => checkforSingleRoom === true,
    //       then: () => Yup.string().strict(false)
    //         .trim()
    //         .required("Break fast price is required")
    //         // .matches(/^[0-9]+$/, "Decimal values is not allowed in break fast price"),
    //         .matches(/^\d+(,\d{1,2})?$/, "Decimal values is not allowed in the break fast price (e.g. 5, 5,75)"),
    //       otherwise: () => Yup.string(),
    //     }),
    //   // .trim().matches(/^[0-9]+$/, "Break fast price should be valid").required('Break fast price is required'),
    //   totalQuantityDoubleRoom: Yup.string()
    //     .strict(false).when("checkforDoubleRoom", {
    //       is: (checkforDoubleRoom) => checkforDoubleRoom === true,
    //       then: () => Yup.string().strict(false)
    //         .trim()
    //         .required("Total quantity is required")
    //         .matches(/^[0-9]+$/, "Total quantity should be valid"),
    //       otherwise: () => Yup.string(),
    //     }),
    //   // .trim().matches(/^[0-9]+$/, "Total quantity should be valid").required('Total quantity is required'),
    //   priceDoubleRoom: Yup.string()
    //     .strict(false).when("checkforDoubleRoom", {
    //       is: (checkforDoubleRoom) => checkforDoubleRoom === true,
    //       then: () => Yup.string().strict(false)
    //         .trim()
    //         .required("price is required")
    //         // .matches(/^[0-9]+$/, "price should be valid"),
    //         .matches(/^\d+(,\d{1,2})?$/, "Please enter a valid price (e.g. 5, 5,75)"),
    //       otherwise: () => Yup.string(),
    //     }),
    //   breakfastPriceDoubleRoom: Yup.string()
    //     .strict(false).when("checkforDoubleRoom", {
    //       is: (checkforDoubleRoom) => checkforDoubleRoom === true,
    //       then: () => Yup.string().strict(false)
    //         .trim()
    //         .required("Break fast price is required")
    //         // .matches(/^[0-9]+$/, "Break fast price should be valid"),
    //         .matches(/^\d+(,\d{1,2})?$/, "Decimal values is not allowed in the break fast price (e.g. 5, 5,75)"),
    //       otherwise: () => Yup.string(),
    //     }),
    // }))
  });


  const handleSort = (e, column) => {
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  const deleteFunction = (item) => {
    Swal.fire({
      customClass: "swal-wide",
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        eventsService
          .DeleteHotel({ o_id: item._id })
          .then(res => {
            if (res && res.success) {
              Swal.fire({
                icon: 'success',
                text: res.message,
                ...SWAL_SETTINGS
              })
              getList();
            } else {
              Swal.fire({
                icon: 'error',
                text: handleServerValidations(res),
                ...SWAL_SETTINGS
              })
            }
          })
          .catch(err => console.log("err", err))
      }
    }).catch(err => console.log("err", err))
  }

  const parseDate = (dateStr) => {
    if (!dateStr) return new Date('');
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return new Date(dateStr);
    }
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('-');
      return new Date(`${year}-${month}-${day}`);
    }
    return new Date('');
  };

  // const goToEdit = async (item) => {
  //   setWorkHotel('edit');
  //   formikRef.current.setFieldValue("hotelName", item.name);
  //   formikRef.current.setFieldValue("description", item.description);
  //   // customCkeditorRef?.current?.setValue(item.description, "editor100");
  //   // formikRef.current.setFieldValue("description_de", item.description_de)
  //   // customCkeditorRefTwo?.current?.setValue(item.description_de, "editor99");

  //   formikRef.current.setFieldValue("hotelStartDate", new Date(item.start_date));
  //   formikRef.current.setFieldValue("hotelEndDate", new Date(item.end_date));
  //   formikRef.current.setFieldValue("images", 'edit');
  //   setPreviewImage(item.gallery_images);
  //   setImages(item.gallery_images);
  //   formikRef.current.setFieldValue("cityTax", item.city_tax);
  //   formikRef.current.setFieldValue("tax", item.tax);
  //   formikRef.current.setFieldValue("breakfastTax", item.breakfast_tax);
  //   const newTotalHotel = [];
  //   var date1 = new Date(item.start_date);

  //   for (let i = 0; i < item.quota.length; i++) {
  //     // var tomorrow = date1;
  //     var tomorrow = new Date(date1);
  //     const obj = {
  //       id: i + 1,
  //       totalQuantitySingleRoom: item.quota[i].single_room.total_quantity,
  //       priceSingleRoom: item.quota[i].single_room.price,
  //       breakfastPriceSingleRoom: item.quota[i].single_room.breakfast_price,
  //       totalQuantityDoubleRoom: item.quota[i].double_room.total_quantity,
  //       priceDoubleRoom: item.quota[i].double_room.price,
  //       breakfastPriceDoubleRoom: item.quota[i].double_room.breakfast_price,
  //       checkforSingleRoom: item.quota[i].single_room.is_available,
  //       checkforDoubleRoom: item.quota[i].double_room.is_available,
  //       _id: item.quota[i]._id,
  //       date: moment(tomorrow).format("DD-MM-YYYY")
  //     }
  //     console.log(obj.date)
  //     newTotalHotel.push(obj)

  //     tomorrow.setDate(date1.getDate() + 1)
  //     // tomorrow.setDate(date1.getDate() + 1)
  //     date1 = tomorrow
  //   }
  //   formikRef.current.setFieldValue("hotelTotalDays", newTotalHotel)

  //   // const file = await getImageFileFromUrl(item.gallery_images[0]);
  //   // formikRef.current.setFieldValue("images", file)
  //   setHotelId(item._id);
  // }

  // const onFormSubmit = (values, resetForm) => {
  //   setSubmitted(true);
  //   let formData = new FormData();
  //   formData.append("name", values.hotelName);
  //   formData.append("description", values.description);
  //   // formData.append("description_de", values.description_de);

  //   for (let i = 0; i < images.length; i++) {
  //     formData.append("gallery_images", images[i]);
  //   }

  //   // formData.append("start_date", values.hotelStartDate);
  //   // formData.append("end_date", values.hotelEndDate);
  //   formData.append("start_date", new Date(values.hotelStartDate).toISOString().split("T")[0]);
  //   formData.append("end_date", new Date(values.hotelEndDate).toISOString().split("T")[0]);

  //   formData.append("city_tax", values.cityTax);
  //   formData.append("tax", values.tax);
  //   formData.append("breakfast_tax", values.breakfastTax);
  //   formData.append("event_id", params.id);

  //   if (!hotelId) {

  //     const quota = [];
  //     for (let i = 0; i < values.hotelTotalDays.length; i++) {
  //       quota.push({
  //         "single_room": {
  //           total_quantity: values.hotelTotalDays[i].totalQuantitySingleRoom,
  //           price: values.hotelTotalDays[i].priceSingleRoom,
  //           breakfast_price: values.hotelTotalDays[i].breakfastPriceSingleRoom,
  //           is_available: values.hotelTotalDays[i].checkforSingleRoom
  //         },
  //         "double_room": {
  //           total_quantity: values.hotelTotalDays[i].totalQuantityDoubleRoom,
  //           price: values.hotelTotalDays[i].priceDoubleRoom,
  //           breakfast_price: values.hotelTotalDays[i].breakfastPriceDoubleRoom,
  //           is_available: values.hotelTotalDays[i].checkforDoubleRoom
  //         },
  //         // date: moment(values.hotelTotalDays[i].date).format("DD-MM-YYYY")
  //         date: values.hotelTotalDays[i].date
  //       })
  //     }
  //     formData.append(`quota`, JSON.stringify(quota));

  //     eventsService
  //       .AddHotel(formData)
  //       .then((response) => {
  //         if (response?.success) {
  //           Swal.fire({
  //             icon: "success",
  //             text: response.message,
  //             ...SWAL_SETTINGS,
  //           });
  //           setWorkHotel('add');
  //           resetForm()
  //           setPreviewImage([])
  //           customCkeditorRef.current.setValue("", 'editor100')
  //           // customCkeditorRefTwo.current.setValue("")
  //           imageInputRef.current.value = ""
  //           if (saveAndNext) {
  //             setSaveAndNext(false);
  //             setTimeout(() => {
  //               // resetForm({ values: "" });
  //               navigate(`/admin/event-management/events/add/agenda/${params.id}`);
  //             }, 2000);
  //           } else {
  //             getList();
  //           }
  //         } else {
  //           Swal.fire({
  //             icon: "error",
  //             text: handleServerValidations(response),
  //             ...SWAL_SETTINGS,
  //           });
  //           setSubmitted(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("error ====> ", error);
  //       });
  //   } else {
  //     formData.append("o_id", hotelId);

  //     const parseDateString = (dateStr) => {
  //       const [day, month, year] = dateStr.split('-');
  //       return new Date(`${year}-${month}-${day}`);
  //     }
  //     const quota = [];
  //     for (let i = 0; i < values.hotelTotalDays.length; i++) {

  //       const rawDate = parseDateString(values.hotelTotalDays[i].date); 
  //       const formattedDate = rawDate.toISOString().split("T")[0];
  //       quota.push({
  //         "single_room": {
  //           total_quantity: values.hotelTotalDays[i].totalQuantitySingleRoom,
  //           price: values.hotelTotalDays[i].priceSingleRoom,
  //           breakfast_price: values.hotelTotalDays[i].breakfastPriceSingleRoom,
  //           is_available: values.hotelTotalDays[i].checkforSingleRoom
  //         },
  //         "double_room": {
  //           total_quantity: values.hotelTotalDays[i].totalQuantityDoubleRoom,
  //           price: values.hotelTotalDays[i].priceDoubleRoom,
  //           breakfast_price: values.hotelTotalDays[i].breakfastPriceDoubleRoom,
  //           is_available: values.hotelTotalDays[i].checkforDoubleRoom
  //         },
  //         _id: values.hotelTotalDays[i]._id,
  //         // date: values.hotelTotalDays[i].date
  //         date: formattedDate,
  //         // date: moment(values.hotelTotalDays[i].date).format("DD-MM-YYYY")
  //       })
  //     }
  //     console.log("quota", quota);
  //     formData.append(`quota`, JSON.stringify(quota));

  //     eventsService
  //       .EditHotel(formData)
  //       .then((response) => {
  //         // setSubmitting(false);
  //         if (response?.success) {
  //           Swal.fire({
  //             icon: "success",
  //             text: response.message,
  //             ...SWAL_SETTINGS,
  //           });
  //           resetForm();
  //           setPreviewImage([]);
  //           customCkeditorRef.current.setValue("", 'editor100');
  //           imageInputRef.current.value = ""
  //           if (saveAndNext) {
  //             setSaveAndNext(false);
  //             setTimeout(() => {
  //               // resetForm({ values: "" });
  //               navigate(`/admin/event-management/events/add/agenda/${params.id}`,);
  //             }, 2000);
  //           } else {
  //             getList()
  //           }
  //         } else {
  //           Swal.fire({
  //             icon: "error",
  //             text: handleServerValidations(response),
  //             ...SWAL_SETTINGS,
  //           });
  //           setSubmitted(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("error ====> ", error);
  //       });
  //   }
  // }

  // const formatDecimalForUI = (num) => {
  //   if (num === null || num === undefined) return '';
  //   return num.toString().replace('.', ','); // 5.75 -> "5,75"
  // };


  const resetHotelForm = (resetForm) => {
    resetForm({ values: hotelsInitialValues });
    setHotelId(undefined);
    setFormMode(FORM_MODES.HIDDEN);
    setPreviewImage([]);
    setImages([]);
    setQuotaStore({});
    setSubmitted(false);
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
    customCkeditorRef.current?.setValue("", "editor100");
  };

  const openAddForm = () => {
    formikRef.current?.resetForm({ values: hotelsInitialValues });
    setHotelId(undefined);
    setFormMode(FORM_MODES.ADD);
    setPreviewImage([]);
    setImages([]);
    setQuotaStore({});
    setSubmitted(false);
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
    customCkeditorRef.current?.setValue("", "editor100");
  };

  const populateHotelForm = (item, mode) => {
    setFormMode(mode);
    formikRef.current.setFieldValue("hotelName", item.name);
    formikRef.current.setFieldValue("description", item.description);
    customCkeditorRef.current?.setValue(item.description || "", "editor100");
    formikRef.current.setFieldValue("hotelStartDate", new Date(item.start_date));
    formikRef.current.setFieldValue("hotelEndDate", new Date(item.end_date));
    formikRef.current.setFieldValue("images", 'edit');
    console.log('item.gallery_images', item.gallery_images, mode == FORM_MODES.DUPLICATE);
    if(mode != FORM_MODES.DUPLICATE){
      setPreviewImage(item.gallery_images);
      setImages(item.gallery_images);
    }
    formikRef.current.setFieldValue("cityTax", formatDecimalForUI(item.city_tax));
    formikRef.current.setFieldValue("tax", formatDecimalForUI(item.tax));
    formikRef.current.setFieldValue("breakfastTax", formatDecimalForUI(item.breakfast_tax));

    const roomCategories =
      item.room_categories?.length > 0
        ? item.room_categories.map((c) => ({
            id: c.id,
            label: c.label || (c.occupancy === "double" ? "Double room" : "Single room"),
            occupancy: c.occupancy === "double" ? "double" : "single",
          }))
        : defaultRoomCategories();

    const newTotalHotel = [];

    for (let i = 0; i < item.quota.length; i++) {
      const quotaItem = item.quota[i];
      newTotalHotel.push({
        id: i + 1,
        categoryQuota: mergeServerCategoryQuota(roomCategories, quotaItem),
        ...(mode === FORM_MODES.EDIT ? { _id: quotaItem._id } : {}),
        date: moment(quotaItem.date).format("DD-MM-YYYY"),
      });
    }

    formikRef.current.setFieldValue("roomCategories", roomCategories);
    formikRef.current.setFieldValue("hotelTotalDays", newTotalHotel);
    setHotelId(mode === FORM_MODES.EDIT ? item._id : undefined);
    setTimeout(() => syncFormikBaseline(), 100);
  };

  const goToEdit = async (item) => {
    populateHotelForm(item, FORM_MODES.EDIT);
  };

  const goToDuplicate = async (item) => {
    populateHotelForm(item, FORM_MODES.DUPLICATE);
  };

  const onFormSubmit = (values, resetForm) => {
    setSubmitted(true);
    
    let formData = new FormData();
    formData.append("name", values.hotelName);
    formData.append("description", values.description);
    // formData.append("description_de", values.description_de);

    for (let i = 0; i < images.length; i++) {
      formData.append("gallery_images", images[i]);
    }

    // STEP 1: Normalize and sort the date array
    const sortedHotelDays = [...values.hotelTotalDays].map((day) => {
      const parsedDate = moment(day.date, ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601]).format("YYYY-MM-DD");
      return { ...day, date: parsedDate };
    }).sort((a, b) => moment(a.date).diff(moment(b.date)));

    // STEP 2: Set start and end dates based on sorted data
    const startDateFormatted = sortedHotelDays[0]?.date || "";
    const endDateFormatted = sortedHotelDays[sortedHotelDays.length - 1]?.date || "";

    let startDate = new Date(startDateFormatted);
    startDate.setHours(0, 0, 0, 0);
    let isoStartDate = startDate.toISOString();

    let endDate = new Date(endDateFormatted);
    endDate.setHours(23, 59, 59, 999);
    let isoEndDate = endDate.toISOString();

    formData.append("start_date", isoStartDate);
    formData.append("end_date", isoEndDate);

    formData.append("city_tax", values.cityTax);
    formData.append("tax", values.tax);
    formData.append("breakfast_tax", values.breakfastTax);
    formData.append("event_id", params.id);

    const toServerCategorySlot = (cq) => {
      if (!cq?.enabled) {
        return {
          total_quantity: 0,
          price: 0,
          breakfast_price: 0,
          is_available: false,
        };
      }
      return {
        total_quantity: parseInt(String(cq.totalQuantity), 10) || 0,
        price: cq.price === "" || cq.price == null ? 0 : cq.price,
        breakfast_price:
          cq.breakfastPrice === "" || cq.breakfastPrice == null ? 0 : cq.breakfastPrice,
        is_available: true,
      };
    };

    // STEP 3A: Filter room categories - only keep those enabled in at least one day (or primary categories)
    const filteredRoomCategories = values.roomCategories.filter((cat) => {
      // Always keep primary categories
      if (cat.id === PRIMARY_SINGLE_CAT_ID || cat.id === PRIMARY_DOUBLE_CAT_ID) {
        return true;
      }
      // For custom categories, only keep if enabled in at least one day
      return sortedHotelDays.some((day) => day.categoryQuota?.[cat.id]?.enabled);
    });

    // STEP 3: Construct quota (category_quotas + legacy single_room / double_room from primary categories)
    const quota = sortedHotelDays.map((day) => {
      const category_quotas = {};
      filteredRoomCategories.forEach((cat) => {
        const cq = day.categoryQuota?.[cat.id] || emptyCategoryRow();
        category_quotas[cat.id] = toServerCategorySlot(cq);
      });
      const sp = category_quotas[PRIMARY_SINGLE_CAT_ID];
      const dp = category_quotas[PRIMARY_DOUBLE_CAT_ID];
      return {
        single_room: {
          total_quantity: sp?.total_quantity ?? 0,
          price: sp?.price ?? 0,
          breakfast_price: sp?.breakfast_price ?? 0,
          is_available: !!sp?.is_available,
        },
        double_room: {
          total_quantity: dp?.total_quantity ?? 0,
          price: dp?.price ?? 0,
          breakfast_price: dp?.breakfast_price ?? 0,
          is_available: !!dp?.is_available,
        },
        category_quotas,
        date: day.date,
        ...(day._id ? { _id: day._id } : {}),
      };
    });

    formData.append("quota", JSON.stringify(quota));
    formData.append("room_categories", JSON.stringify(filteredRoomCategories));

    // STEP 4: Decide API call
    const serviceCall = hotelId ? eventsService.EditHotel : eventsService.AddHotel;
    if (hotelId) formData.append("o_id", hotelId);

    // STEP 5: Make the API call
    serviceCall(formData)
      .then((response) => {
        if (response?.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          resetForm();
          setPreviewImage([]);
          customCkeditorRef.current?.setValue("", "editor100");
          imageInputRef.current.value = "";

          if (saveAndNext) {
            setSaveAndNext(false);
            setTimeout(() => {
              skipUnsavedPromptRef.current = true;
              navigate(`/admin/event-management/events/add/agenda/${params.id}`);
            }, 2000);
          }
          else {
            getList();
          }
          setHotelId(undefined);
          setFormMode(FORM_MODES.HIDDEN);
          setImages([]);
          setQuotaStore({});
          setStatusUpdate(!statusUpdate);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
          setSubmitted(false);
        }
      })
      .catch((error) => {
        console.log("error ====> ", error);
        setSubmitted(false);
      });
  };

  return (
    <>
      <Formik
        validateOnBlur={false}
        innerRef={formikRef}
        validate={(values) => {
          const errors = {};
          const currencyName = showdefault?.currency?.name === "Euro";

          if (!values.tax) {
            errors.tax = "Tax is required";
          } else {
            if (currencyName) {
              if (!/^\d+(,\d{1,2})?$/.test(values.tax)) {
                errors.tax = "Please enter a valid tax (e.g. 5 or 5,75)";
              }
            } else {
              if (!/^\d+(\.\d{1,2})?$/.test(values.tax)) {
                errors.tax = "Please enter a valid tax (e.g. 5 or 5.75).";
              }
            }
          }

          if (!values.cityTax) {
            errors.cityTax = "City tax is required";
          } else {
            if (currencyName) {
              if (!/^\d+(,\d{1,2})?$/.test(values.cityTax)) {
                errors.cityTax = "Please enter a valid city tax (e.g. 5 or 5,75)";
              }
            } else {
              if (!/^\d+(\.\d{1,2})?$/.test(values.cityTax)) {
                errors.cityTax = "Please enter a valid city tax (e.g. 5 or 5.75).";
              }
            }
          }

          if (!values.breakfastTax) {
            errors.breakfastTax = "Breakfast tax is required";
          } else {
            if (currencyName) {
              if (!/^\d+(,\d{1,2})?$/.test(values.breakfastTax)) {
                errors.breakfastTax = "Please enter a valid breakfast tax (e.g. 5 or 5,75)";
              }
            } else {
              if (!/^\d+(\.\d{1,2})?$/.test(values.breakfastTax)) {
                errors.breakfastTax = "Please enter a valid pbreakfast taxrice (e.g. 5 or 5.75).";
              }
            }
          }


          if (!values.hotelTotalDays || !Array.isArray(values.hotelTotalDays) || values.hotelTotalDays.length === 0) {
            errors.hotelTotalDays = "Array must have at least 1 item";
          } else {
            const hotelDayErrors = [];
            values.hotelTotalDays.slice(0, -1).forEach((day, index) => {
              const dayErrors = {};
              values.roomCategories.forEach((cat) => {
                const cq = day.categoryQuota?.[cat.id];
                if (!cq?.enabled) return;
                const catErr = {};
                if (!cq.totalQuantity) {
                  catErr.totalQuantity = "Total quantity is required";
                } else if (!/^[0-9]+$/.test(String(cq.totalQuantity))) {
                  catErr.totalQuantity = "Total quantity should be valid";
                }
                if (!cq.price) {
                  catErr.price = "Price is required";
                } else if (currencyName) {
                  if (!/^\d+(,\d{1,2})?$/.test(String(cq.price))) {
                    catErr.price = "Please enter a valid price (e.g. 5 or 5,75)";
                  }
                } else if (!/^\d+(\.\d{1,2})?$/.test(String(cq.price))) {
                  catErr.price = "Please enter a valid price (e.g. 5 or 5.75).";
                }
                if (!cq.breakfastPrice) {
                  catErr.breakfastPrice = "Breakfast price is required";
                } else if (currencyName) {
                  if (!/^\d+(,\d{1,2})?$/.test(String(cq.breakfastPrice))) {
                    catErr.breakfastPrice = "Please enter a valid breakfast price (e.g. 5 or 5,75)";
                  }
                } else if (!/^\d+(\.\d{1,2})?$/.test(String(cq.breakfastPrice))) {
                  catErr.breakfastPrice = "Please enter a valid breakfast price (e.g. 5 or 5.75).";
                }
                if (Object.keys(catErr).length > 0) {
                  if (!dayErrors.categoryQuota) dayErrors.categoryQuota = {};
                  dayErrors.categoryQuota[cat.id] = catErr;
                }
              });
              if (Object.keys(dayErrors).length > 0) {
                hotelDayErrors[index] = dayErrors;
              }
            });
            if (hotelDayErrors.length > 0) {
              errors.hotelTotalDays = hotelDayErrors;
            }
          }

          return errors;
        }}

        enableReinitialize
        initialValues={hotelsInitialValues}
        validationSchema={hotelsValidationSchema}
        onSubmit={(values, { resetForm }) => {
          onFormSubmit(values, resetForm)
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          resetForm,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="d-flex justify-content-end mb-3">
                <button
                  type="button"
                  className="btn ripple btn-main-primary signbtn"
                  onClick={openAddForm}
                >
                  Add New
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                  <thead>
                    <tr>
                      <th className="sr_head">S.No</th>
                      <th>
                        <div className="sorting_column">
                          <span>Name</span>
                          <Sorting
                            sort={sorting}
                            handleSort={handleSort}
                            column="title"
                          />
                        </div>
                      </th>
                      <th>City tax</th>
                      <th>Tax %</th>
                      <th>Breakfast tax %</th>
                      <th className="action_head">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <tr>
                        <td colSpan={7}>
                          <Loader />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {hotelList.length ? (
                          hotelList.map((row, i) => {
                            return (
                              <tr key={i}>
                                <td>{offset + (i + 1)}</td>
                                <td>{row.name ? row.name : "N/A"}</td>
                                <td>{row.city_tax ? formatDecimalForUI(row.city_tax) : "N/A"}</td>
                                <td>{row.tax ? formatDecimalForUI(row.tax) : "N/A"}</td>
                                <td>{row.breakfast_tax ? formatDecimalForUI(row.breakfast_tax) : "N/A"}</td>
                                <td>
                                  <div className="d-flex">
                                    <button
                                      type="button"
                                      className="btn ripple btn-success mx-1"
                                      onClick={() => {
                                        goToEdit(row);
                                      }}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      type="button"
                                      className="btn ripple btn-info mx-1"
                                      onClick={() => {
                                        goToDuplicate(row);
                                      }}
                                    >
                                      Duplicate
                                    </button>
                                    {hasPermission('/admin/event-management/events/edit/hotels/delete') ?
                                      <button
                                        type="button"
                                        className="btn ripple btn-secondary"
                                        onClick={() => {
                                          deleteFunction(row);
                                        }}
                                      >
                                        Delete
                                      </button>
                                      : null}
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No records
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              <div
                className="d-flex align-items-center"
                id="example1_info"
                role="status"
                aria-live="polite"
              >
                <b>Total Records : {datalength ? datalength : "0"}</b>
                {datalength && datalength > 0 ?
                  <div className="d-flex align-items-center ms-3">
                    <span className="me-2 fw-semibold">Records per page:</span>
                    <select
                      className="form-select"
                      style={{ width: "150px" }}
                      // value={itemperpage}
                      // onChange={(e) => {
                      //   const value = e.target.value;
                      //   const parsedValue = value === `${datalength}` ? datalength : Number(value);
                      //   setItemPerPage(parsedValue);
                      //   sessionStorage.setItem("recordsPerPage", parsedValue);
                      //   setPage(1); // optional: reset pagination
                      // }}
                      value={itemperpage === "all" ? `${datalength}` : itemperpage}
                      onChange={(e) => {
                        const value = e.target.value;
                        const isShowAll = value === `${datalength}`;
                        const parsedValue = isShowAll ? "all" : Number(value);

                        setItemPerPage(parsedValue);
                        sessionStorage.setItem("recordsPerPage", parsedValue);
                      }}
                    >
                      {RECORDS_PER_PAGE_OPTIONS &&
                        RECORDS_PER_PAGE_OPTIONS.map((option) => (
                          <option key={option.key} value={option.key}>
                            {option.label}
                          </option>
                        ))}
                      <option value={`${datalength}`}>Show all ({datalength})</option>
                    </select>
                  </div>
                  : null}
              </div>
              {datalength && datalength > 0 && itemperpage !== "all" ? (
                <CustomPagination
                  datalength={datalength}
                  itemperpage={itemperpage}
                  currentPage={page}
                  setPage={setPage}
                  pageRoute={[
                    {
                      name: "Events",
                      path: `/admin/event-management/events/edit/hotels/${params.id}`,
                    },
                  ]}
                />
              ) : (
                ""
              )}

              {formMode !== FORM_MODES.HIDDEN && (
                <>
              <hr />
              <h6 className="main-content-label mb-3">{formMode === FORM_MODES.EDIT ? "Edit Hotel" : formMode === FORM_MODES.DUPLICATE ? "Duplicate Hotel" : "Add Hotel"}</h6>
              <div className="col-md-12 text-center form-group">
                {/* <h4 style={{textAlign: "left"}} className="pb-3">Add a new hotel</h4> */}
                <label htmlFor="hotelName" className="text-left d-flex">
                  Hotel name :<span className="requirestar">*</span>{" "}
                </label>
                <input
                  name="hotelName"
                  id="hotelName"
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.hotelName}
                  className="form-control"
                />
                <span className="text-danger d-flex text-left">
                  <ErrorMessage name={"hotelName"} />
                </span>
              </div>

              <div className='col-lg-12 text-center form-group'>
                <label htmlFor='description' className='text-left d-flex'>Description:<span className="requirestar">*</span></label>
                {
                  formMode === FORM_MODES.EDIT ?
                    <>
                      <CustomCkeditor
                        name={"editor100"}
                        fieldname={"description"}
                        setFieldValue={setFieldValue}
                        value={values?.description}
                        setFieldTouched={setFieldTouched}
                        ref={customCkeditorRef}
                      /></>

                    : <CustomCkeditor
                      fieldname={"description"}
                      setFieldValue={setFieldValue}
                      value={values.description}
                      ref={customCkeditorRef}
                    />
                }
                <span className='text-danger d-flex text-left'>{touched.description && errors.description}</span>
              </div>

              <div className="col-md-12 text-center form-group">
                <label htmlFor="images" className="text-left d-flex">
                  Image gallery :<span className="requirestar">*</span>{" "}
                  <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Recommended Size (1290x486)</Tooltip>}>
                    <span className='field-more-info mt-1 ms-1 cp'>?</span>
                  </Whisper>
                </label>
                <input
                  ref={imageInputRef}
                  className="form-control h-auto"
                  id="images"
                  name="images"
                  accept="image/*"
                  type="file"
                  multiple={true}
                  onChange={(event) => {
                    setPreviewImage(Object.values(event.target.files));
                    setImages(Object.values(event.target.files));
                    setFieldValue('images', Object.values(event.target.files));
                  }}
                />
                <span
                  className="text-danger d-flex text-left"
                  id="errortext"
                >
                  {touched.images && errors.images}
                </span>
              </div>
              <div className='mt-3 file_preview_container'>
                {previewimage.map(item => (
                  <div className="file_preview_wrapper mb-4">
                    {formMode === FORM_MODES.EDIT ? (
                      <></>
                    ) : (
                      <span className='file_preview_close' onClick={() => handleImageDelete(previewimage, item.name, setFieldValue)}>
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </span>
                    )}

                    <img src={item.name ? URL.createObjectURL(item) : item} style={{ height: "100px" }} alt="Preview" className="preview-image mx-2" />
                  </div>
                )
                )}
              </div>

              <div className="col-md-6 text-center form-group">
                <label htmlFor="hotelStartDate" className="text-left d-flex">
                  Start date :<span className="requirestar">*</span>{" "}
                  <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>These define the earliest possible check-in date and the latest possible check-out date for the hotel quota.</Tooltip>}>
                    <span className='field-more-info mt-1 ms-1 cp'>?</span>
                  </Whisper>
                </label>
                {/* <CustomDateTimePickerHotel
                  // disabled={workHotel === "edit" ? true : false}
                  placeholder={"Start date"}
                  setField={setFieldValue}
                  fieldname={`hotelStartDate`}
                  setFieldTouched={setFieldTouched}
                  // setHotelTotalDays={setHotelTotalDays}
                  formikRef={formikRef}
                  value={values.hotelStartDate}
                  correspondingEndDate={formikRef.current?.values?.hotelEndDate}
                  correspondingEndDateName={'hotelEndDate'}
                  endDateValue={values.hotelEndDate}
                /> */}
                <CustomDateTimePickerHotel
                  placeholder={"Start date"}
                  setField={setFieldValue}
                  fieldname={`hotelStartDate`}
                  setFieldTouched={setFieldTouched}
                  formikRef={formikRef}
                  value={values.hotelStartDate}
                  correspondingEndDate={formikRef.current?.values?.hotelEndDate}
                  correspondingEndDateName={'hotelEndDate'}
                  endDateValue={values.hotelEndDate}
                  quotaStore={quotaStore}
                  setQuotaStore={setQuotaStore}
                />

                <span className="text-danger d-flex text-left">
                  <ErrorMessage name={"hotelStartDate"} />
                </span>
              </div>

              <div className="col-md-6 text-center form-group">
                <label htmlFor="hotelEndDate" className="text-left d-flex">
                  End date :<span className="requirestar">*</span>{" "}
                  <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>These define the earliest possible check-in date and the latest possible check-out date for the hotel quota.</Tooltip>}>
                    <span className='field-more-info mt-1 ms-1 cp'>?</span>
                  </Whisper>
                </label>
                {/* <CustomDateTimePickerHotel
                  // disabled={workHotel === "edit" ? true : false}
                  placeholder={"End date"}
                  setField={setFieldValue}
                  fieldname={`hotelEndDate`}
                  setFieldTouched={setFieldTouched}
                  // setHotelTotalDays={setHotelTotalDays}
                  formikRef={formikRef}
                  value={values.hotelEndDate}
                  endDate={true}
                  correspondingStartDate={formikRef?.current?.values?.hotelStartDate}
                /> */}
                <CustomDateTimePickerHotel
                  placeholder={"End date"}
                  setField={setFieldValue}
                  fieldname={`hotelEndDate`}
                  setFieldTouched={setFieldTouched}
                  formikRef={formikRef}
                  value={values.hotelEndDate}
                  endDate={true}
                  correspondingStartDate={formikRef?.current?.values?.hotelStartDate}
                  quotaStore={quotaStore}
                  setQuotaStore={setQuotaStore}
                />

                <span className="text-danger d-flex text-left">
                  <ErrorMessage name={"hotelEndDate"} />
                </span>
              </div>

              <div className="col-md-4 text-center form-group">
                <label htmlFor="cityTax" className="text-left d-flex">
                  City tax:<span className="requirestar">*</span>{" "}
                  <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>City tax is a tax to be paid by guests with
                    overnight stays. It is VAT-exempt in Germany. For other
                    locations, please refer to local regulations.
                    Enter here the amount (not percent) of city tax that
                    must be paid per person per night. In locations
                    without city tax just enter 0.</Tooltip>}>
                    <span className='field-more-info mt-1 ms-1 cp'>?</span>
                  </Whisper>
                </label>
                <input
                  name="cityTax"
                  id="cityTax"
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.cityTax}
                  className="form-control"
                />
                <span className="text-danger d-flex text-left">
                  <ErrorMessage name={"cityTax"} />
                </span>
              </div>

              <div className="col-md-4 text-center form-group">
                <label htmlFor="tax" className="text-left d-flex">
                  Tax %:<span className="requirestar">*</span>{" "}
                </label>
                <input
                  name="tax"
                  id="tax"
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.tax}
                  className="form-control"
                />
                <span className="text-danger d-flex text-left">
                  <ErrorMessage name={"tax"} />
                </span>
              </div>

              <div className="col-md-4 text-center form-group">
                <label htmlFor="breakfastTax" className="text-left d-flex">
                  Breakfast tax %:<span className="requirestar">*</span>{" "}
                </label>
                <input
                  name="breakfastTax"
                  id="breakfastTax"
                  type="text"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.breakfastTax}
                  className="form-control"
                />
                <span className="text-danger d-flex text-left">
                  <ErrorMessage name={"breakfastTax"} />
                </span>
              </div>
                  
              {values.hotelTotalDays && values.hotelTotalDays.length > 0 && (
                <div className="col-md-2 form-group mb-2">
                  <button
                    type="button"
                    className="btn bg-dark btn-dark mr-2"
                    onClick={() => {
                      const newId = `cat_${Date.now()}`;
                      const nextCats = [
                        ...values.roomCategories,
                        {
                          id: newId,
                          label: "New room category",
                          occupancy: "single",
                        },
                      ];
                      setFieldValue("roomCategories", nextCats);

                      const days = values.hotelTotalDays.map((d) => ({
                        ...d,
                        categoryQuota: {
                          ...(d.categoryQuota || {}),
                          [newId]: emptyCategoryRow(),
                        },
                      }));
                      setFieldValue("hotelTotalDays", days);
                    }}
                  >
                    + Add new room category
                  </button>
                </div>
              )}

              {values.hotelTotalDays.slice(0, -1).map((item, index) => (
                <React.Fragment key={item.date + "-" + (item._id || index)}>
                <h4>Quota</h4>
                {index < values.hotelTotalDays.length - 1 && (
                  <h5>
                    {parseDate(item.date).toISOString().split("T")[0]} - {" "}
                    {parseDate(values.hotelTotalDays[index + 1].date)
                      .toISOString()
                      .split("T")[0]}
                  </h5>
                )}
                {values.roomCategories.map((cat, catIndex) => (
                  <div className="col-md-12 text-center form-group" key={cat.id}>
                    <div className="d-flex justify-content-start align-items-start flex-wrap">
                      <div className="d-flex align-items-center" style={{ height: 38, minWidth: 200 }}>
                        <input
                          type="checkbox"
                          className="mr-2"
                          style={{ borderRadius: 50 }}
                          checked={!!item.categoryQuota?.[cat.id]?.enabled}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            if (!item.categoryQuota?.[cat.id]) {
                              setFieldValue(
                                `hotelTotalDays[${index}].categoryQuota.${cat.id}`,
                                { ...emptyCategoryRow(), enabled: checked }
                              );
                            } else {
                              setFieldValue(
                                `hotelTotalDays[${index}].categoryQuota.${cat.id}.enabled`,
                                checked
                              );
                            }
                          }}
                        />
                        <input
                          type="text"
                          className="form-control"
                          value={cat.label}
                          onChange={(e) => {
                            const next = values.roomCategories.map((c, i) =>
                              i === catIndex ? { ...c, label: e.target.value } : c
                            );
                            setFieldValue("roomCategories", next);
                          }}
                          placeholder="Room category name"
                        />
                      </div>
                      {cat.id !== PRIMARY_SINGLE_CAT_ID &&
                        cat.id !== PRIMARY_DOUBLE_CAT_ID && (
                        <div className="d-flex align-items-center ms-2" style={{ height: 38 }}>
                          <select
                            className="form-select"
                            style={{ width: 160 }}
                            value={cat.occupancy}
                            onChange={(e) => {
                              const next = values.roomCategories.map((c, i) =>
                                i === catIndex ? { ...c, occupancy: e.target.value } : c
                              );
                              setFieldValue("roomCategories", next);
                            }}
                          >
                            <option value="single">Single occupancy</option>
                            <option value="double">Double occupancy</option>
                          </select>
                        </div>
                      )}
                      {cat.id !== PRIMARY_SINGLE_CAT_ID &&
                        cat.id !== PRIMARY_DOUBLE_CAT_ID &&
                        !item.categoryQuota?.[cat.id]?.enabled && (
                        <button
                          type="button"
                          className="ml-2 op_button danger"
                          style={{ minWidth: 32, height: 38 }}
                          title="Remove room category"
                          aria-label="Remove room category"
                          onClick={() => {
                            const nextCats = values.roomCategories.filter(
                              (c) => c.id !== cat.id
                            );
                            const days = values.hotelTotalDays.map((d) => {
                              const cq = { ...(d.categoryQuota || {}) };
                              delete cq[cat.id];
                              return { ...d, categoryQuota: cq };
                            });
                            setFieldValue("roomCategories", nextCats);
                            setFieldValue("hotelTotalDays", days);
                          }}
                        >
                          <i className="ti-close"></i>
                        </button>
                      )}
                      {item.categoryQuota?.[cat.id]?.enabled && (
                      <>
                        <div className="col-md-2 text-center form-group">
                          <input
                            placeholder="Total quantity"
                            type="number"
                            className="form-control"
                            value={item.categoryQuota?.[cat.id]?.totalQuantity ?? ""}
                            onChange={(e) =>
                              setFieldValue(
                                `hotelTotalDays[${index}].categoryQuota.${cat.id}.totalQuantity`,
                                e.target.value
                              )
                            }
                          />
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage
                              name={`hotelTotalDays[${index}].categoryQuota.${cat.id}.totalQuantity`}
                            />
                          </span>
                        </div>
                        <div className="col-md-2 text-center form-group">
                          <input
                            placeholder="Price"
                            type="text"
                            className="form-control"
                            value={item.categoryQuota?.[cat.id]?.price ?? ""}
                            onChange={(e) =>
                              setFieldValue(
                                `hotelTotalDays[${index}].categoryQuota.${cat.id}.price`,
                                e.target.value
                              )
                            }
                          />
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage
                              name={`hotelTotalDays[${index}].categoryQuota.${cat.id}.price`}
                            />
                          </span>
                        </div>
                        <div className="col-md-2 text-center form-group">
                          <input
                            placeholder="Breakfast price"
                            type="text"
                            className="form-control"
                            value={item.categoryQuota?.[cat.id]?.breakfastPrice ?? ""}
                            onChange={(e) =>
                              setFieldValue(
                                `hotelTotalDays[${index}].categoryQuota.${cat.id}.breakfastPrice`,
                                e.target.value
                              )
                            }
                          />
                          <span className="text-danger d-flex text-left">
                            <ErrorMessage
                              name={`hotelTotalDays[${index}].categoryQuota.${cat.id}.breakfastPrice`}
                            />
                          </span>
                        </div>
                      </>
                      )}
                    </div>
                  </div>
                ))}
                <hr />
                </React.Fragment>
              ))}
              <div className="mt-5">
                <button
                  className="btn btn-info mr-2"
                  type="submit"
                // disabled={submitted ? true : null}
                >
                  <i className="fa fa-floppy-o mx-1" aria-hidden="true"></i>
                  Save
                </button>
                <button
                  className="btn btn-success mr-2"
                  type="submit"
                  onClick={() => {
                    if (!Object.values(errors).length) {
                      setSaveAndNext(true);
                    }
                  }}
                // disabled={submitted ? true : null}
                >
                  <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                  Save & Next
                </button>
                <button
                  className="btn ripple btn-secondary"
                  type="button"
                  disabled={submitted ? true : null}
                  onClick={() => resetHotelForm(resetForm)}
                >
                  <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                  Cancel
                </button>
              </div>
                </>
              )}
            </div>
          </form>
        )}
      </Formik>
    </>
  )
}

export default Hotels;
